import { countries } from './json/countries-convert.json';

function countryAlpha3(alpha2: string) {
  const alpha2_item = countries[alpha2 as keyof typeof countries];

  if (!alpha2_item) {
    return 'UNK';
  }

  return alpha2_item || 'UNK';
}

export default countryAlpha3;
